import { render, staticRenderFns } from "./SalesAdd.vue?vue&type=template&id=9cf8f182&scoped=true"
import script from "./SalesAdd.vue?vue&type=script&lang=js"
export * from "./SalesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf8f182",
  null
  
)

export default component.exports